// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (max-width:720px){.loginWrapper[data-v-9e06be9a]{width:100%;height:100%}.mobileDisplace[data-v-9e06be9a]{margin-top:42px}.hideLabel[data-v-9e06be9a]{top:-38px}}", ""]);
// Exports
module.exports = exports;
